var _defs, _path, _path2, _rect, _rect2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSocial(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 1200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#54575a;}.cls-3{fill:#3d85c6;}.cls-4{fill:#47b972;}.cls-5{fill:#ec951a;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard 7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M124.6,1177.64a96.18,96.18,0,0,1-95.94-95.31l-6.3-957.09a96.05,96.05,0,0,1,95.31-96.57l957.73-6.3a96.18,96.18,0,0,1,95.94,95.31l6.3,957.09a96.05,96.05,0,0,1-95.31,96.57Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1075.41,32.36a86.15,86.15,0,0,1,85.93,85.38l6.3,957.09a86.26,86.26,0,0,1-85.38,86.51l-957.1,6.3h-.56a86.16,86.16,0,0,1-85.94-85.38l-6.3-957.09a86.26,86.26,0,0,1,85.38-86.51l957.1-6.3h.57m0-20h-.7l-957.09,6.3C59.34,19,12,67,12.36,125.3l6.3,957.09c.38,58,48,105.25,105.94,105.25h.7l957.09-6.3c58.27-.38,105.63-48.37,105.25-106.64l-6.3-957.09c-.38-58-48-105.25-105.94-105.25Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 392.84,
    y: 472.78,
    width: 415.91,
    height: 51.88,
    rx: 22.38,
    ry: 22.38,
    transform: "translate(-163.44 338.65) rotate(-27.87)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 394.24,
    y: 685.77,
    width: 415.91,
    height: 51.88,
    rx: 22.38,
    ry: 22.38,
    transform: "translate(390.53 -196.24) rotate(27.11)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M412.85,704.45c-53.95,0-98.13-43.9-98.48-97.85a98.5,98.5,0,0,1,97.85-99.14h.66c53.95,0,98.13,43.9,98.48,97.85a98.61,98.61,0,0,1-97.85,99.15Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M412.88,515a91,91,0,0,1,.58,182h-.61a91,91,0,0,1-.58-182h.62m0-15h-.71a106,106,0,0,0,.68,212h.71a106,106,0,0,0-.68-212Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M784.51,500c-53.95,0-98.13-43.9-98.48-97.85A98.5,98.5,0,0,1,783.88,303h.66c53.95,0,98.13,43.9,98.48,97.85A98.5,98.5,0,0,1,785.17,500Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M784.55,310.5a91,91,0,0,1,.58,182h-.61a91,91,0,0,1-.58-182h.62m0-15h-.71a106,106,0,0,0,.68,212h.71a106,106,0,0,0-.68-212Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M787.12,897c-53.95,0-98.13-43.9-98.48-97.85A98.5,98.5,0,0,1,786.49,700h.66c53.95,0,98.13,43.9,98.48,97.85A98.5,98.5,0,0,1,787.79,897Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M787.16,707.5a91,91,0,0,1,.58,182h-.61a91,91,0,0,1-.58-182h.62m0-15h-.71a106,106,0,0,0,.68,212h.71a106,106,0,0,0-.68-212Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocial);
export default __webpack_public_path__ + "static/media/social.a6fd044a2aebcc8342d613cb9f3ff953.svg";
export { ForwardRef as ReactComponent };